import { render, staticRenderFns } from "./BaseChatView.vue?vue&type=template&id=e584f638&scoped=true&"
import script from "./BaseChatView.vue?vue&type=script&lang=js&"
export * from "./BaseChatView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e584f638",
  null
  
)

export default component.exports